import type { FaireProductEntity } from "../../entity_types/product";

export const p_paq5uqw4ew: FaireProductEntity = {
  token: "p_paq5uqw4ew",
  type: "product",
  name: "ESKIMO KISSES - Winter Shearling Boots",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/4b40de1e467d8c3567bc89e42b8631da644b527372a15e7f7ac79ab471fed112.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ddbf0bd6a32aa3e62f4b64315ba06b1b26a08f408ceb61711852d774b58e778.jpeg",
    "https://cdn.faire.com/fastly/60d7df09943d025dbbd962215d5556a56c9a938e782e5908dc85cdb26dd55247.jpeg",
    "https://cdn.faire.com/fastly/69d5a54d2a3ad2f1bf1dd3e8ba4240feb4ccf7db038a327ee029b9a5a0802206.jpeg",
    "https://cdn.faire.com/fastly/c77b1fd260f001de965c40df027c5bb89242c89f33e1c8d655f58e87f164ad87.jpeg",
    "https://cdn.faire.com/fastly/2521ccd1c640a943b12306530eece13e1f0e0e2bf40114df04a61e981f7008d8.jpeg",
    "https://cdn.faire.com/fastly/264b483e8443ba9bc901e7b1e00feae485e3e5ce25a43a976ea9acd531739def.jpeg",
    "https://cdn.faire.com/fastly/9b5d3413086c1b9c0ad6a46e6e194dc6a49f8e8daafd800cb674d2cab5fde852.jpeg",
    "https://cdn.faire.com/fastly/dfc0f9e6d1a2b9bfbf1f380dc579b0c5aeffb0c60c009a952ad6c83654ad9ff5.jpeg",
    "https://cdn.faire.com/fastly/7550249ba0b709783d925428b4fa4bdb024db55ed6393ad55360b9101499ed62.jpeg",
    "https://cdn.faire.com/fastly/cb42595a45f9df69e5bcaa37acb7bf8cf245777918f6333b199a514e0505e800.jpeg",
  ],
  priceDollars: 27.5,
  description:
    "Turn heads and stay cozy with Eskimo Kisses, the ultimate winter statement boot. Featuring a plush faux-shearling exterior, pointed toe, and sleek contrast sole, these knee-high boots bring warmth and high-fashion drama in one. Perfect for bold fashion lovers looking to stand out, Eskimo Kisses is available in Beige and Black to match any cold-weather aesthetic.\n\n𝐎𝐎𝐓𝐃:\nStyle Eskimo Kisses with a knit sweater dress and an oversized coat for an effortlessly chic winter look, or go for edgy contrast by pairing them with leather leggings and a fitted turtleneck. Want a cozy après-ski vibe? Throw on a puffer jacket and matching mittens for the ultimate snowy-day outfit.\n\n• Knee High Boot\n• Faux Fur Shearling\n• Western Style Cut\n• Block Heel\n• Colors: Beige, Black",
  tags: [],
  msrpDollars: 55,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:16.175Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
